import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SiteLayout from "@/components/SiteLayout";
import AuthCallback from "@/pages/AuthCallback";
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import LocationsPage from "@/pages/LocationsPage";
import QuotePage from "@/pages/QuotePage";
import ContractorPage from "@/pages/ContractorPage";
import PrivacyPage from "@/pages/PrivacyPage";
import GuidePage from "@/pages/GuidePage";
import LuxuryLandscapingPage from "@/pages/LuxuryLandscapingPage";
import AdminPage from "@/pages/AdminPage";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<SiteLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/locations" element={<LocationsPage />} />
        <Route path="/luxury-landscaping-calgary" element={<LuxuryLandscapingPage />} />
        <Route path="/quote" element={<QuotePage />} />
        <Route path="/contractors" element={<ContractorPage />} />
        <Route path="/guide" element={<GuidePage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
      </Route>
      <Route path="/admin" element={<AdminPage />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRouter />
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}
